// extracted by mini-css-extract-plugin
export default {"wrapper":"PanelWithoutContainer_wrapper__HwXnt","container":"PanelWithoutContainer_container__YPy5k"};